import { IDonorProfileDeclinesData } from '@nkr/models/donor-profile';
import { Col, Label, Row, Table } from 'react-bootstrap';

interface IProps {
    data: IDonorProfileDeclinesData
}

const Declines = (props: IProps) => {
    if (props.data == null) {
        return null
    }

    return (
        <>
            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} className='text-right decline-label'>
                    <strong>Accepted:</strong>
                </Col>

                <Col xs={12} lg={3}>
                    <Label bsStyle='success'>{props.data.acceptedCount}</Label>
                </Col>
            </Row>

            <Row>
                {props.data.hardBlockReasonList.map(item => {
                    let f = props.data.declinesByReasonList.find(x => x.reason.toUpperCase() == item.value.toUpperCase());

                    return (
                        <Col xs={12} lg={6} style={{ marginBottom: 10 }}>
                            <Col xs={12} lg={6} className='text-right decline-label'>Declined for <strong>{item.description}:</strong></Col>
                            <Col xs={12} lg={6}><Label bsStyle='danger'>{f != null ? f.reasonCount : 0}</Label></Col>
                        </Col>
                    );
                })}
            </Row>

            <div style={{ paddingTop: 20, paddingBottom: 10 }}>Declined Comments</div>

            <div style={{ height: 300, overflowY: 'scroll', padding: 5, border: '1px solid #ccc', borderRadius: 4 }}>
                <Table condensed bordered style={{ marginBottom: 0 }}>
                    <thead>
                        <tr style={{ backgroundColor: '#133366', color: '#fff' }}>
                            <th></th>
                            <th>Decision Date/Time</th>
                            <th>Comments</th>
                            <th>Declined By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.declineCommentsList.map((decline, index) =>
                            <tr key={'decline-' + index}>
                                <td>{index + 1}</td>
                                <td>{decline.decisionDateTime}</td>
                                <td>{decline.hardBlockComments}</td>
                                <td>{decline.userName}</td>
                            </tr>
                        )}

                        {props.data.declineCommentsList.length == 0 && (
                            <tr>
                                <td colSpan={4}>No decline comments at this time...</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </>
    );
}

export default Declines;